import * as React from "react";
const NotePendingSvg = (props) => (
  <svg
    width={57}
    height={56}
    viewBox="0 0 57 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} width={56} height={56} rx={28} fill="#FFEAD5" />
    <path
      d="M28.5 32v-4m0-4h.01m9.99 4c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10"
      stroke="#FFAF4A"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default NotePendingSvg;
